// Sketch Hub Constants
// Centralized constants for the sketch module

export const QUADRANTS = {
  urgentImportant: { label: 'Urgent & Important', shortLabel: 'Do First', color: '#EF4444', position: 'top-left' },
  importantNotUrgent: { label: 'Important, Not Urgent', shortLabel: 'Schedule', color: '#F59E0B', position: 'top-right' },
  urgentNotImportant: { label: 'Urgent, Not Important', shortLabel: 'Delegate', color: '#3B82F6', position: 'bottom-right' },
  notUrgentNotImportant: { label: 'Not Urgent, Not Important', shortLabel: 'Eliminate', color: '#6B7280', position: 'bottom-left' },
};

export const PRIORITY_COLORS = {
  high: '#EF4444',
  medium: '#F59E0B',
  low: '#10B981',
};

export const PRIORITY_FLAGS = {
  1: { label: 'P1 - Critical', color: '#EF4444', bgColor: 'bg-red-500/20' },
  2: { label: 'P2 - High', color: '#F59E0B', bgColor: 'bg-amber-500/20' },
  3: { label: 'P3 - Medium', color: '#3B82F6', bgColor: 'bg-blue-500/20' },
  4: { label: 'P4 - Low', color: '#10B981', bgColor: 'bg-emerald-500/20' }
};

export const ITEM_SHAPES = {
  sticky: { name: 'Sticky Note', className: 'rounded-2xl', minWidth: 120, minHeight: 80, icon: 'note' },
  circle: { name: 'Circle', className: 'rounded-full', minWidth: 80, minHeight: 80, icon: 'circle' },
  pill: { name: 'Pill', className: 'rounded-full', minWidth: 100, minHeight: 40, icon: 'pill' },
  tag: { name: 'Tag', className: 'rounded-xl', minWidth: 80, minHeight: 32, icon: 'tag' },
  card: { name: 'Card', className: 'rounded-2xl', minWidth: 140, minHeight: 60, icon: 'card' },
  // Artifact types
  photo: { name: 'Photo', className: 'rounded-xl', minWidth: 100, minHeight: 100, icon: 'image' },
  link: { name: 'Link', className: 'rounded-xl', minWidth: 120, minHeight: 60, icon: 'link' },
  document: { name: 'Document', className: 'rounded-xl', minWidth: 100, minHeight: 80, icon: 'doc' },
  website: { name: 'Website', className: 'rounded-xl', minWidth: 120, minHeight: 80, icon: 'globe' },
};

export const BOARD_COLUMNS = {
  now: { label: 'Now', color: '#EF4444', description: 'Do immediately' },
  next: { label: 'Next', color: '#F59E0B', description: 'Up next in queue' },
  someday: { label: 'Someday', color: '#3B82F6', description: 'Future consideration' },
  done: { label: 'Done', color: '#10B981', description: 'Completed' }
};

export const PROJECT_TYPES = {
  conflict: {
    id: 'conflict',
    name: 'Conflict Resolution',
    description: 'Transform conflict into understanding using the ElchmE process',
    color: '#EF4444',
  },
  creative: {
    id: 'creative',
    name: 'Creative Project',
    description: 'Brainstorm and develop creative ideas',
    color: '#8B5CF6',
  },
  planning: {
    id: 'planning',
    name: 'Planning & Strategy',
    description: 'Strategic planning and goal setting',
    color: '#3B82F6',
  },
  custom: {
    id: 'custom',
    name: 'Custom Project',
    description: 'Create your own project type',
    color: '#6B7280',
  }
};

export const PROJECT_STATUS = {
  active: { label: 'Active', color: '#10B981', bgColor: 'bg-emerald-500/20' },
  paused: { label: 'Paused', color: '#F59E0B', bgColor: 'bg-amber-500/20' },
  completed: { label: 'Completed', color: '#3B82F6', bgColor: 'bg-blue-500/20' },
  archived: { label: 'Archived', color: '#6B7280', bgColor: 'bg-gray-500/20' }
};
